import state from "./state";
import ApiService from "@/core/services/api.service";

export default {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  fetchTeacherGroupMemberNotInList(context, payload) {
    ApiService.setHeader();
    return ApiService.query("school/group/employees/not", {
      params: {
        "page[size]": 30,
        "page[number]": state.pagination.current_page ?? 1,
        "filter[first_name]": state.filters.name,
        id: payload.id,
        employee_type: 1,
      },
    }).then((res) => {
      context.commit("setTeacherGroupMemberNotInList", res.data.data);
      context.commit(
        "setTeacherGroupMemberNotInListPagination",
        res.data.meta.pagination
      );
      return res;
    });
  },

  /**
   *
   * @param context
   * @param payload
   */
  changeTeacherGroupMemberNotInListNameFilters(context, payload) {
    console.log("Name", payload.name);

    let curFilters = state.filters;
    curFilters.name = payload.name;

    context.commit("setTeacherGroupMemberNotInListFilters", curFilters);
  },

  selectTeacherGroupMemberSaveModification(context, payload) {
    console.log("Info : ", context, payload);

    context.commit("switchTeacherGroupMemberSelectionSave", payload.id);
  },
};
